const API_DOMAIN = process.env.API_DOMAIN || 'NEED_TO_INITIALISE:API_DOMAIN';
const API_AUTH_TOKEN = process.env.API_AUTH_TOKEN || 'NEED_TO_INITIALISE:API_AUTH_TOKEN';
const CLIENT_ID_SESSION_API =
  process.env.CLIENT_ID_SESSION_API || 'NEED_TO_INITIALISE:CLIENT_ID_SESSION_API';
export { API_DOMAIN, API_AUTH_TOKEN, CLIENT_ID_SESSION_API };



// WEBPACK FOOTER //
// ./src/EnvVars.js